(function () {
    "use strict";

    app.controller("CalculatorController", [
        "$rootScope", "$scope", "CalculatorService", "TrackingService", "$sce",
        function ($rootScope, $scope, calculator, $trackingService, $sce) {
            var $domChangeNotification = $("#dom-change-notification");
            var $calculator = $("#calculator");
            var $calculatorTop = $calculator.offset().top;
            var $window = $(window);
            var alertDomChange = function (message) {
                $domChangeNotification.html("");
                window.setTimeout(function () {
                    $domChangeNotification.html("<span role=\"alert\">" + message + "</span>");
                    window.setTimeout(function () {
                        $domChangeNotification.html("");
                    }, 1000);
                }, 25);
            };
            var scrollIntoView = function () {
                var $windowHeight = $window.height();
                var $windowTop = $window.scrollTop();
                var $calculatorHeight = $calculator.height();
                if ($calculatorTop < $windowTop || $calculatorTop > $windowTop + $windowHeight - $calculatorHeight) {
                    var scrollPosition = $calculatorTop;
                    if ($calculatorHeight > $windowHeight) {
                        scrollPosition = $calculatorTop + $calculatorHeight - $windowHeight;
                    }
                    $("html, body").animate({ scrollTop: scrollPosition }, 1000);
                }
            };
            $scope.trackPlan = function(planName) {
                $trackingService.trigger("prepaid-family-plan", planName);
            };



            $scope.minimumNumberOfLines = calculator.minimumNumberOfLines;
            $scope.maximumNumberOfLines = calculator.maximumNumberOfLines;

            $scope.totalBeforeDiscount = calculator.totalBeforeDiscount;
            $scope.discountAmount = calculator.discountAmount;
            $scope.totalAfterDiscount = calculator.totalAfterDiscount;
            $scope.totalMultiLineDiscount = calculator.totalMultiLineDiscount;
            $scope.totalAutoPayDiscount = calculator.totalAutoPayDiscount;

            $scope.activeLines = function () {
                return _.filter(calculator.lines, { active: true });
            };

            $scope.setNumberOfLines = function (numberOfLines) {
                numberOfLines = Math.min(Math.max(numberOfLines, calculator.minimumNumberOfLines), calculator.maximumNumberOfLines);
                while (numberOfLines !== $scope.numberOfLines) {
                    if (numberOfLines < $scope.numberOfLines) {
                        $scope.removeLine();
                    }
                    else {
                        $scope.addLine();
                    }
                }
                document.activeElement.blur();
            };

            $scope.addLine = function (scroll, focus) {
                if (calculator.addLine()) {
                    var line = $scope.numberOfLines = calculator.numberOfLines;
                    alertDomChange("Line added");
                    if (scroll) {
                        window.setTimeout(function () {
                            scrollIntoView();
                        }, 0);
                    }
                    if (focus) {
                        window.setTimeout(function () {
                            document.querySelector(".line-items > :nth-child(" + line + ") select").focus();
                        }, 10);
                    }
                }
            };
            $scope.removeLine = function (scroll, focus) {
                if (calculator.removeLine()) {
                    $scope.numberOfLines = calculator.numberOfLines;
                    alertDomChange("Line removed");
                    if (scroll) {
                        window.setTimeout(scrollIntoView, 0);
                    }
                    if (focus) {
                        window.setTimeout(function () {
                            document.querySelector(".line-items > :last-child select").focus();
                        }, 10);
                    }
                }
            };

            $scope.autoPayEnabled = function () {
                return calculator.autoPayEnabled;
            };

            $scope.toggleAutoPay = function () {
                calculator.toggleAutoPay();
                $scope.autoPayEnabled = calculator.autoPayEnabled;
            };

            $scope.reset = function () {
                calculator.reset();
                window.setTimeout(scrollIntoView, 0);
            };

            angular.element(document).ready(function () {
                calculator.initialize();

                $scope.autoPayEnabled = calculator.autoPayEnabled;
                $scope.numberOfLines = calculator.numberOfLines;
                $scope.plans = calculator.plans.map(function (plan) {
                    return angular.extend(plan, {
                        inclusions: plan.inclusions.map(function (inclusion) { return $sce.trustAsHtml(inclusion) })
                    });
                });
                $scope.lines = calculator.lines;

                $scope.$apply();
            });

            angular.element(document).scroll(function () {
                var header = document.getElementById("calculator-header");
                if (document.body.parentElement.scrollTop >= header.offsetTop) {
                    header.className = "calc-head text-center stuck";
                }
                else {
                    header.className = "calc-head text-center";
                }
            });

            $rootScope.$on("reset", function () {
                $scope.autoPayEnabled = calculator.autoPayEnabled;
                $scope.numberOfLines = calculator.numberOfLines;
            });
        }
    ]);
})();